export function loadLocalState(key: string) {
  try {
    const serializedState = localStorage.getItem(key)
    if (!serializedState) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    return undefined
  }
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function saveLocalState(key: string, state: any) {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(key, serializedState)
  } catch (err) {
    console.log(err)
  }
}

export const local = {
  loadState: loadLocalState,
  saveState: saveLocalState,
}

export const session = {
  loadState: (key: string) => {
    try {
      const serializedState = sessionStorage.getItem(key)
      if (!serializedState) return undefined
      return JSON.parse(serializedState)
    } catch (e) {
      return undefined
    }
  },
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  saveState: (key: string, state: any) => {
    try {
      const serializedState = JSON.stringify(state)
      sessionStorage.setItem(key, serializedState)
    } catch (err) {
      console.log(err)
    }
  },
}
